module.exports = __webpack_public_path__ + "static/media/banner3.1e86298c.jpg";